import React, { ComponentProps, forwardRef, memo } from 'react'

import { Text } from './Text'

type OptionalProps = {
  optional?: true
  // require optionalText, when optional is true
  optionalText: string
}

type DefaultProps = {
  optional?: false
}

type AdditionalProps = OptionalProps | DefaultProps

export type LabelProps = Omit<
  ComponentProps<typeof Text>,
  'as' | 'bold' | 'variant'
> & {
  htmlFor?: string
} & AdditionalProps

export const Label = memo(
  forwardRef<HTMLLabelElement, LabelProps>(
    (
      {
        children,
        optional = false,
        size = 'sm',
        mb = 'sm',
        va = 'middle',
        display = 'inline-block',
        ...rest
      },
      ref,
    ) => {
      const isOptional = optional
      const optionalText = isOptional
        ? (rest as OptionalProps).optionalText
        : undefined

      return (
        <Text
          {...{ ref, size, as: 'label', mb, va, display, bold: true, ...rest }}>
          {children}
          {optional ? (
            <>
              {' '}
              <Text {...{ size, italic: true }}>({optionalText})</Text>
            </>
          ) : null}
        </Text>
      )
    },
  ),
)
